export default __webpack_public_path__ + "static/media/movipack_feature1.45bfb88f.svg";